import {UUID} from '../../../shared/types/uuid.type';
import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {catchError, concatMap, map, tap} from 'rxjs/operators';
import {forkJoin, Observable, of} from 'rxjs';
import {MatSnackBar} from '@angular/material/snack-bar';
import {stopManyDestinations, stopManyDestinationsFailure, stopManyDestinationsSuccess} from './destination.stop-many.actions';
import {DestinationsService} from '../../../services/api/destinations/destinations.service';
import {Destination} from '../../../services/api/destinations/destination.model';
import {loadDestinations, manyDestinationsStopped} from '../actions/destinations.actions';


@Injectable()
export class DestinationStopManyEffects {

  // noinspection JSUnusedGlobalSymbols
  stopManyDestinations$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(stopManyDestinations),
        concatMap((payload: { ids: UUID[] }) => {
          const ids: UUID[] = payload.ids;
          const requests: Observable<Destination>[] = ids
            .map((destinationId: UUID): Observable<Destination> =>
              this.service.stopDestination(destinationId)
            );

          return forkJoin(requests)
            .pipe(
              map(() => stopManyDestinationsSuccess({ids})),
              catchError(error => of(stopManyDestinationsFailure({error})))
            );
        }));
  });

  // noinspection JSUnusedGlobalSymbols
  stopManyDestinationsSuccess$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(stopManyDestinationsSuccess),
        tap(() =>
          this.snackBar.open('Destinations successfully stopped', 'Success', {duration: 3000})),
        map((data: { ids: UUID[] }) => manyDestinationsStopped({ids: data.ids}))
      );
  });

  // noinspection JSUnusedGlobalSymbols
  stopManyDestinationsFailure$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(stopManyDestinationsFailure),
        tap((error: { error: any }) =>
          this.snackBar.open(`Failed to stop destinations: ${error.error}`, 'Error', {duration: 3000})),
        map(() => loadDestinations())
      );
  });

  constructor(
    private readonly actions$: Actions,
    private readonly service: DestinationsService,
    private readonly snackBar: MatSnackBar
  ) {
  }

}
